module.exports = "/_next/static/images/image1AboutUs-2x-5166fbb459df94769cd4d3c61d63153a.jpg.webp";